import ProductWork from 'umg-ember-backend/components/record-explorer/for/product-work';

<template>
  <ProductWork @records={{@model}} @recordType='product-work' />
</template>
